import React, { Fragment, useState, useEffect, useRef } from "react";
import { Input } from '../core/Forms';
import IntlTelInput from 'intl-tel-input';
import $ from 'jquery';
import 'bootstrap/js/dist/carousel';

function PhoneNumber({ submitPhone, submitCode, phoneNumber, canEdit, isLoading, onTimePasswordMode }){

	const carouselRef = useRef(null);
	const phoneInputRef = useRef(null);
	const intlTelInputRef = useRef(null);

	useEffect( () => {
		if(!carouselRef.current){
			return; }

		$(carouselRef.current).carousel({
			interval: false,
			keyboard: false,
			touch: false
		});

	}, [carouselRef.current]);


	useEffect( () => {
		if(!phoneInputRef.current){
			return; }
		
		const intlTelInput = IntlTelInput(phoneInputRef.current, {
			utilsScript: `https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/${window.intlTelInputGlobals.version}/js/utils.js`,
			onlyCountries: ['MX', 'US'],
			preferredCountries: ['MX'],
			dropdownContainer: carouselRef.current.parentNode,
			allowDropdown: canEdit
		});

		intlTelInputRef.current = intlTelInput;

		return () => {
			intlTelInput.destroy(); }
	
	}, [phoneInputRef.current, canEdit]);


	useEffect( () => {
		if(carouselRef.current){

			if(phoneNumber.confirmed && !onTimePasswordMode){
				$(carouselRef.current).carousel(0);
			}else if(phoneNumber.sms_failed || phoneNumber.phone_invalid || phoneNumber.phone_taken){
				$(carouselRef.current).carousel(0);
			}else if(phoneNumber.sms_sent_at){
				const timePassed = (new Date() - new Date(phoneNumber.sms_sent_at)) / 1000;

				if(timePassed < 60){
					$(carouselRef.current).carousel(1);
				}else{
					$(carouselRef.current).carousel(0);
				}
			}
		}

		if(intlTelInputRef.current && phoneNumber.phone_number){
			intlTelInputRef.current.setCountry(phoneNumber.country_alpha2);
			intlTelInputRef.current.setNumber(phoneNumber.phone_number); }
	}, [phoneNumber]);


	function submitPhoneProxy(event){
		event.preventDefault();
		
		const phone_number = {};
		phone_number.phone_number = intlTelInputRef.current.getNumber();
		phone_number.country_alpha2 = intlTelInputRef.current.getSelectedCountryData().iso2;
		submitPhone(phone_number);

		return false;
	}

	
	function submitCodeProxy(event){
		event.preventDefault();

		const codeInput = event.target['code'];
		submitCode(codeInput.value);

		return false;
	}


	let invalidFeedback;
	if(phoneNumber.sms_failed){
		if(phoneNumber.sms_retry_in){
			invalidFeedback = (<div className="invalid-feedback d-block">Debes esperar al menos {phoneNumber.sms_retry_in} segundos para enviar otro SMS</div>);
		}else{
			invalidFeedback = (<div className="invalid-feedback d-block">No pudimos enviar un SMS a este número</div>);
		}
	}else if(phoneNumber.phone_invalid){
		invalidFeedback = (<div className="invalid-feedback d-block">No es un número celular válido</div>);
	}else if(phoneNumber.phone_taken){
		invalidFeedback = (<div className="invalid-feedback d-block">Este número ya ha sido utilizado</div>);
	}else if(phoneNumber.confirmation_failed){
		invalidFeedback = (<div className="invalid-feedback d-block">El código es inválido</div>);
	}

	return (<div ref={carouselRef} className="carousel slide">
		<div className="carousel-inner">
			
			<div className="carousel-item active">
				<form onSubmit={submitPhoneProxy}>
					<div className="form-row">
						<div className="form-group col-8">
							<label className="w-100">{onTimePasswordMode ? 
									'Mensaje SMS' : 'Celular (Opcional)'}

								<input ref={phoneInputRef} 
									className={ 'form-control' + (invalidFeedback ? 
										' is-invalid' : (canEdit && phoneNumber.confirmed ? 
										' is-valid' : ''))} 
									name="recoveryPhone" type="tel" disabled={!canEdit} />
								
								{invalidFeedback ? 
									invalidFeedback : 
									<small className="form-text text-muted">
										{onTimePasswordMode ? 
											'Enviaremos un SMS con un código para verificar tu identidad' :
											'Enviaremos un SMS con un código para validar tu número celular'}</small>}
							</label>
						</div>

						<div className="form-group col-4">
							{(phoneNumber.confirmed && !onTimePasswordMode) ? 
								(<button type="submit" className="btn btn-secondary w-100 mt-4" disabled={!canEdit || isLoading}>
									{canEdit && isLoading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
									{canEdit ? 'Cambiar' : 'Confirmado'}
								</button>) : 
								(<button type="submit" className="btn btn-primary w-100 mt-4" disabled={isLoading}>
									{isLoading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
									Enviar SMS
								</button>)
							}
						</div>
					</div>
				</form>
			</div>

			<div className="carousel-item">
				<form onSubmit={submitCodeProxy}>
					<div className="form-row">
						<div className="form-group col-8">
							<label className="w-100">Código de confirmación
								<div className="input-group">
									<div className="input-group-prepend">
										<button type="button" className="btn btn-outline-secondary" 
											onClick={ () => $(carouselRef.current).carousel(0) }>Reintentar</button>
									</div>
									<input className={ 'form-control' + (invalidFeedback ? ' is-invalid' : '')} 
										name="code" type="text" pattern="[0-9]{6}" autoComplete="one-time-code" />
								</div>
								{invalidFeedback ? 
									invalidFeedback : 
									<small className="form-text text-muted">Si en 1 minuto no recibes un SMS, revisa tu número y vuelve a intentarlo</small>}
							</label>
						</div>

						<div className="form-group col-4">
							<button type="submit" className="btn btn-secondary w-100 mt-4" disabled={isLoading}>
								{isLoading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
								Verificar
							</button>
						</div>
					</div>
				</form>
			</div>

		</div>
	</div>);
}

export default PhoneNumber;
